import {MouseEventHandler} from 'react';

import styled, {css} from 'styled-components';

import Button from '~/shared/components/Button';
import {BackArrow, BackArrowSmall} from '~/shared/components/BackArrow';
import {flexCenter} from '~/shared/theme/FlexLayout';
import {getLocalizationService} from '~/shared/services/localisationService';

type BackButtonProps = {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  ariaLabel?: string;
  variant?: 'default' | 'small';
  backButtonText?: string;
};

const smallVariantStyle = css`
  width: 20px;
  padding: 1px;
`;

const defaultVariantStyle = css`
  gap: 4px;
`;

const StyledButton = styled(Button)<{variant: BackButtonProps['variant']}>`
  height: 36px;
  ${({variant}) => (variant === 'small' ? smallVariantStyle : defaultVariantStyle)}
  ${flexCenter}
`;

const BackButton = ({className, onClick, ariaLabel, variant = 'default', backButtonText}: BackButtonProps) => {
  const {t} = getLocalizationService();
  return (
    <StyledButton type="button" onClick={onClick} aria-label={ariaLabel} variant={variant} className={className}>
      {variant === 'small' && <BackArrow />}
      {variant === 'default' && (
        <>
          <BackArrowSmall />
          {backButtonText || t('back_2')}
        </>
      )}
    </StyledButton>
  );
};

export default BackButton;
